module.exports = __webpack_public_path__ + "img/kaia.736d5fd0.webp";